import { CreatorWing, WingDivisionType } from '@/types/creator';
import { Graphics } from 'pixi.js';
import ConfigurationRenderer from '../ConfigurationRenderer';
import DrawableObject from './DrawableObject';
import Wing from './Wing';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { COLORS, WINDOW } = RENDERER_CONFIG;

class Window extends DrawableObject {
	private frame = new Graphics({
		zIndex: WINDOW.Z_INDEX,
	});

	private wingDivisions: WingDivisionType[] = [];
	wings: Wing[] = [];

	constructor(renderer: ConfigurationRenderer) {
		super(renderer);
		this.container.addChild(this.frame);
	}

	setWingsFromCreatorState(
		creatorWings: CreatorWing[],
		wingDivisions: WingDivisionType[]
	) {
		this.wingDivisions = wingDivisions;

		creatorWings.forEach((creatorWing, idx, arr) => {
			const prevDivisionType = this.wingDivisions[idx - 1],
				nextDivisionType = this.wingDivisions[idx];

			const wing = new Wing(
				this.renderer,
				{
					withMosquitoNet: creatorWing.withMosquitoNet,
				},
				creatorWing.isMosquitoError,
				idx === 0,
				idx === arr.length - 1,
				prevDivisionType,
				nextDivisionType,
				arr[idx - 1]?.withMosquitoNet,
				arr[idx + 1]?.withMosquitoNet
			);

			this.container.addChild(wing.container);

			wing.dimensions = {
				width: creatorWing.width,
				height: this.dimensions.height,
			};
			wing.scaledDimensions = {
				width: wing.dimensions.width * this.renderer.scale,
				height: wing.dimensions.height * this.renderer.scale,
			};
			wing.id = creatorWing.id;

			this.wings.push(wing);
		});
	}

	draw() {
		this.frame
			.rect(0, 0, this.scaledDimensions.width, this.scaledDimensions.height)
			.stroke({ color: COLORS.BLACK, pixelLine: true });

		for (const wing of this.wings) {
			wing.draw();
		}
	}

	override destroy() {
		for (const wing of this.wings) {
			wing.destroy();
		}

		super.destroy();
	}
}

export default Window;
